var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurrentStrProperties = function SvgCurrentStrProperties(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.762 17.35 15.62-2.299 15.62 14.19 15.62-11.957 15.88-8.799 15.36 30.203",
    stroke: "#37A3BC"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#37A3BC",
    transform: "translate(0 7.697)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 79.1,
    cy: 31.47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.593,
    cy: 1.022,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.1,
    cy: 9.824,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.187,
    cy: 21.381,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.444,
    cy: 7.522,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.961,
    cy: 9.824,
    r: 1
  })))));
};
export default SvgCurrentStrProperties;